import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  accountSetup: new analytics.Event({
    name: 'Account Creation Submitted',
    description: 'User submits account creation',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['country', 'platform', 'products'],
  }),
};
